export const SoftwareResourcesSearchTypes = {
  SOFTWARE_RESOURCE_SEARCH: 'SOFTWARE_RESOURCE_SEARCH',
  SOFTWARE_RESOURCE_LAST_SEARCH: 'SOFTWARE_RESOURCE_LAST_SEARCH',
};
